var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _path10, _rect3, _rect4, _path11, _path12, _rect5, _circle, _circle2, _circle3, _circle4, _rect6, _polygon, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 300",
    width: "100%",
    height: "100%",
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 304.9,
    y1: 531.31,
    x2: 358.71,
    y2: 531.31,
    gradientTransform: "matrix(0.99, -0.11, -0.11, -0.99, -53.75, 754.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 250.41,
    y1: 769.56,
    x2: 315.25,
    y2: 674.58,
    gradientTransform: "matrix(1, 0, 0, -1, -36.02, 937.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 252.84,
    y1: 852.74,
    x2: 265.76,
    y2: 765.97,
    gradientTransform: "matrix(1, 0, 0, -1, -36.02, 937.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 256.06,
    y1: 769.4,
    x2: 260.88,
    y2: 961.95,
    gradientTransform: "matrix(1, 0, 0, -1, -36.02, 937.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 227.6,
    y1: 875.69,
    x2: 150.51,
    y2: 823.23,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 229.19,
    y1: 858.17,
    x2: 317.27,
    y2: 858.17,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 138.6,
    y1: 758.78,
    x2: 244.51,
    y2: 758.78,
    gradientTransform: "matrix(1, 0, 0, -1, -36.02, 937.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 186.89,
    y1: 816.41,
    x2: 196.17,
    y2: 816.41,
    gradientTransform: "matrix(1, 0, 0, -1, -31, 942.5)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -3597.19,
    y1: 766.03,
    x2: -3499.8,
    y2: 766.03,
    gradientTransform: "translate(-3266.03 937.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 315.56,
    y1: 816.62,
    x2: 302.67,
    y2: 816.24,
    gradientTransform: "matrix(1, 0, 0, -1, -31, 942.5)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 255.04,
    y1: 831.99,
    x2: 256.12,
    y2: 777.28,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 250.48,
    y1: 823.49,
    x2: 250.75,
    y2: 817.57,
    gradientTransform: "matrix(1, 0, 0, -1, -31, 942.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 214.28,
    y1: 820.17,
    x2: 203.88,
    y2: 832.19,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 282.98,
    y1: 817.89,
    x2: 266.3,
    y2: 827.93,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 257,
    y1: 888.36,
    x2: 255.79,
    y2: 1034.86,
    gradientTransform: "matrix(1, 0, 0, -1, -36.02, 937.83)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 311.5,
    y1: 883.11,
    x2: 368.27,
    y2: 898.99,
    gradientTransform: "matrix(1, 0, 0, -1, -36.02, 937.83)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 213.16,
    y1: 879.67,
    x2: 568.93,
    y2: 848.2,
    gradientTransform: "matrix(1, 0, 0, -1, -36.02, 937.83)",
    xlinkHref: "#linear-gradient-12"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "#80_market_analysis_monochromatic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_76_hiking",
    "data-name": "#76_hiking"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.43,175.09c5.21-14,8.43-30.41,1.08-43.45-5-8.86-14-14.58-23-19.36C292.69,98.6,264,89.54,241.67,70.75c-3.66-3.08-7.18-6.44-11.51-8.45-4.59-2.14-9.76-2.6-14.81-3-21.85-1.77-44.27-3.09-65.24,3.27s-40.44,22-45.32,43.36c-3.75,16.49,1.47,34.23-3.37,50.44-4,13.44-14.55,24.28-18.1,37.86-6,22.68,10.14,46.63,31.2,57s45.65,10,69,8.13c11.75-.95,23.53-2.27,34.92-5.29,10.23-2.71,20.18-6.8,30.72-7.47,16.44-1.05,34.67,5.93,48.45-3.09,4.81-3.14,8.39-7.94,13.31-10.91,10.18-6.14,15.24-7.79,17.47-19.72C330.91,199.54,335.74,187.71,340.43,175.09Z",
    fill: "#19b24b",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.79,183.1s-70.9,8.51-78.22,26.37a269.43,269.43,0,0,1-17,33.65s59.21,48.71,106.15,33.34,50.87-25.44,74.58-23.68,43.42-24.56,43.42-35.52-73.31-33.47-85.12-32.75S197.79,183.1,197.79,183.1Z",
    fill: "#19b24b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.45,182.42c0,2.51-.67-1.62-1.68.68-1.34,3.06-3.58,11.9-5.06,14.88-2.55,5.11-.08,11.64,4.26,15.39s10.09,5.33,15.68,6.59c8.27,1.86,17.72,3,24.53-2,6.51-4.81,8.36-13.81,7.82-21.88a104.32,104.32,0,0,0-1.72-11.92L238.47,158a2.21,2.21,0,0,0-2.83-2c-9-.11-23.52.16-31.38,5.19C196.92,165.8,199.43,173.9,199.45,182.42Z",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199,188.21a20.7,20.7,0,0,0,14.5,11.15,25.91,25.91,0,0,0,18.24-3.31c4.46-2.64,8.29-6.63,9.86-11.56a33.85,33.85,0,0,0,1.16-8.62l.39-8.34c-2.52,3.66-7.1,5.32-11.5,5.94C220.57,175,210.92,171,200.55,168c-4.87-1.43-4.78,1.54-4.39,5.67C196.62,178.5,196.93,183.7,199,188.21Z",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.36,153.49s18,29.83,30.63,31.23,31.56.87,45-30.5,15.8-73.1-5.58-80.53C251.39,73.69,146.57,45.7,181.36,153.49Z",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M255.39,154.71c-.38,2-.86,4.18-2.42,5.47-2.14,1.81-5.44,1.22-7.9-.09-5-2.66-8.39-7.6-12.29-11.76a27.7,27.7,0,0,0-5.73-4.74l2.27,4.51a12.65,12.65,0,0,1,1.07,2.58,6.3,6.3,0,0,1,0,3,1.44,1.44,0,0,1-.27.62,1.54,1.54,0,0,1-.77.42,15,15,0,0,1-3.77.47,17,17,0,0,1-6.63-.61c-.62-.23-1.31-.66-1.37-1.33-.08-.93,1.09-1.45,2-1.57,1.27,0,2.47-.16,3.72,0,1.72.16,1.66.3,1.67-1.49,0-2.57,0-5.11-.07-7.71a11.88,11.88,0,0,0-7.1-1c-4.7.92-8.11,4.93-10.74,8.92S202,158.83,198,161.38c-4.51,2.82-12.51,2.25-13.25-4-.8-6.65,3.07-14.84,6.78-20.08a38.16,38.16,0,0,1,20.45-14.5,22.34,22.34,0,0,1,9-.93c3.33.43,6.44,1.92,9.47,3.38l15.91,7.64c2.73,1.31,5.55,2.69,7.44,5.06C257.37,142.49,256.47,149,255.39,154.71Z",
    fill: "url(#linear-gradient-4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M287.37,70.58c.08.75.82,1.23,1.39,1.76,2.37,2.27,1.37,6.43-.87,8.83s-5.37,3.76-7.87,5.89a7.8,7.8,0,0,0-2.85,4.86c-.44,2.63.33,5.46.43,8.42a14.74,14.74,0,0,1-.11,2.49,44,44,0,0,1-7.72,19.66c-1.23,1.67-2.85,3.38-4.92,3.47-3.35.15-5.26-3.72-6.16-6.95a136.77,136.77,0,0,1-4-20q-.48-3.84-.74-7.69c-.66,3.1-5.15,3.85-7.8,2.11-.15-.1-.29-.2-.44-.32-2.35-1.79-3.57-4.73-4.87-7.43-1.4-2.86-3.32-5.85-6.39-6.65-3.48-.89-7,0-10.57-.14-5.47-.23-10.95-.84-16.41-1.25-3-.22-6-.44-8.8.63A8.28,8.28,0,0,0,196,79.87,6,6,0,0,0,193.91,85c-5.54-.19-5.74,4.26-9.84,8s-11.42,7.18-8.23,11.71c3.32,4.72.81,7.83.5,13.41-.51,9.26-3.36,18.22-6.18,27.07-4.28-6.13-8.63-12.41-10.55-19.62-1-3.63-1.59-7.19-2.26-10.69-1-5.58-2.2-11.07-5-16.56a48.67,48.67,0,0,1-3.23-6.51c-1.16-3.43-1-7.15-.76-10.76.46-7.71,1.07-16,5.88-22a17.79,17.79,0,0,1,6.58-5c3.52-1.66,7.28-2.68,10.51-5.15a13.47,13.47,0,0,0,3.87-5.37c1.76-3.93,2.74-8.64,4.86-12a36.52,36.52,0,0,1,15.63-13.4c10.6-4.85,22.77-5.15,34.33-3.57,9.57,1.31,19.16,3.93,27.11,9.41a72.91,72.91,0,0,1,9.44,8.11c7.13,6.95,13.82,14.45,23.24,17.06,3.17.89,6.9,1.4,8.69,4.16s.56,6.83-1.77,9.33-5.49,4-8.21,6.08C288,69.18,287.29,69.81,287.37,70.58Z",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.09,91.32c-1.7,3-3,6.6-1.78,9.84,1.62-.93,3.26-1.82,4.85-2.72l-10.8,16.4c-1.05-5.58-2.2-11.07-5-16.56a48.61,48.61,0,0,1-3.22-6.51c-1.17-3.43-1-7.15-.77-10.76.46-7.71,1.08-16,5.89-22a17.75,17.75,0,0,1,6.57-5,6.2,6.2,0,0,1,1.89,1.4c2.51,2.74,3.13,7.12,4.15,10.54,1.56,5.17,4.15,10.69,2.85,16.19C168.93,85.49,166.77,88.32,165.09,91.32Z",
    fill: "url(#linear-gradient-5)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M278.75,81.34c-2.23,3-2.11,6.76-1.6,10.58.21,1.57.46,3.14.69,4.64a7,7,0,0,1-.26,3.77,3.56,3.56,0,0,1-.34.6c-1.61,2.19-5,1.5-7.54.6-6.26-2.22-10.86-1.64-15-2.57-2.91-.66-5.62-2-8.55-5.58a1.31,1.31,0,0,0-.43-.31c-2.36-1.79-3.58-4.74-4.88-7.44-1.39-2.86-3.31-5.85-6.39-6.64-3.48-.9-7,0-10.57-.14-5.47-.24-11-.84-16.41-1.25-3-.23-6-.44-8.79.63A8.19,8.19,0,0,0,196,79.86c-1.19-.27-2.08-1.12-2.52-3-1.08-4.75.69-11.35,4.15-14.74s8.52-4.28,13.33-4.75c10.23-1,21.19-.57,29.78,5.05,3.94,2.58,7.24,6.14,11.43,8.3,7.63,3.92,16.76,2.55,25.27,3.58,1.44.17,3.11.6,3.65,2C281.8,78.07,279.93,79.77,278.75,81.34Z",
    fill: "url(#linear-gradient-6)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M207.86,105.44a16.12,16.12,0,0,0-4.65-5.6c-7.58-6.19-18.12-8.89-27.53-6.2a18.8,18.8,0,0,0-5.17,2.27,23.26,23.26,0,0,0-6.29,6.77C153.91,118,150.46,136.82,149,155.17c-.33,4.16.12,8.58-1.58,12.39-14.22,31.87-45.2,71.92-44.82,75.56,11.11,9.3,30.43,22.05,39.18,22.37,4.91-9,23.85-73.86,27.83-83.33,1.57-3.72,4.35-11.88,6.65-15.2,6.16-8.92,15.82-9,23.11-17a16.26,16.26,0,0,0,4.07-7,25.58,25.58,0,0,0,.17-6.94,61.37,61.37,0,0,1,1.47-16.71C206.12,114.7,210,110.22,207.86,105.44Z",
    fill: "url(#linear-gradient-7)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 155.08,
    y: 121.31,
    width: 9.28,
    height: 9.55,
    rx: 4.06,
    fill: "#19b24b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 155.89,
    y: 121.31,
    width: 9.28,
    height: 9.55,
    rx: 4.06,
    fill: "url(#linear-gradient-8)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M234.39,105.44a16,16,0,0,1,4.68-5.6c7.57-6.19,18.12-8.89,27.53-6.2a18.74,18.74,0,0,1,5.16,2.27,23.13,23.13,0,0,1,6.29,6.77c10.3,15.31,13.75,34.14,15.22,52.49.33,4.16-.13,8.58,1.57,12.39,14.22,31.86,35.77,47.79,35.4,51.43,6.38,20.56-22,33-33.56,31.94-4.91-9-20-59.31-24-68.79-1.56-3.72-4.34-11.88-6.64-15.2-6.16-8.92-15.8-8.95-23.11-17a16.2,16.2,0,0,1-4.07-7,25.57,25.57,0,0,1-.17-6.94,61.77,61.77,0,0,0-1.47-16.71C236.13,114.7,232.28,110.22,234.39,105.44Z",
    fill: "url(#linear-gradient-9)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 273.82,
    y: 121.31,
    width: 9.28,
    height: 9.55,
    rx: 4.06,
    fill: "#19b24b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 272.88,
    y: 121.31,
    width: 9.28,
    height: 9.55,
    rx: 4.06,
    fill: "url(#linear-gradient-10)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M206.92,111s10.4,6.81,24.39-.54v23.31s-12.38-8.79-23.14,0Z",
    fill: "#19b24b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M206.92,111s10.4,6.81,24.39-.54v23.31s-12.38-8.79-23.14,0Z",
    fill: "url(#linear-gradient-11)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 208.54,
    y: 118.84,
    width: 22.19,
    height: 7.08,
    fill: "#19b24b"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 208.54,
    y: 118.84,
    width: 22.19,
    height: 7.08,
    opacity: 0.69,
    fill: "url(#linear-gradient-12)",
    style: {
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 185.66,
    cy: 125.08,
    r: 25.56,
    fill: "#19b24b"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 185.66,
    cy: 125.08,
    r: 25.56,
    opacity: 0.69,
    fill: "url(#linear-gradient-13)",
    style: {
      isolation: "isolate"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.51,
    cy: 125.32,
    r: 22.13,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.75,
    cy: 125.08,
    r: 25.56,
    fill: "#19b24b"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 252.75,
    cy: 125.08,
    r: 25.56,
    opacity: 0.69,
    fill: "url(#linear-gradient-14)",
    style: {
      isolation: "isolate"
    }
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.59,
    cy: 125.32,
    r: 22.13,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 214.86,
    y: 110.73,
    width: 6.73,
    height: 7.27,
    rx: 2.9,
    fill: "#19b24b"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "196.22 135.09 172.66 135.09 172.66 133.18 194.3 133.18 194.3 110.64 196.22 110.64 196.22 135.09",
    fill: "#19b24b"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 173.51,
    y: 121.58,
    width: 4.53,
    height: 10.13,
    fill: "#19b24b"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 179.79,
    y: 114.13,
    width: 4.53,
    height: 17.58,
    fill: "#19b24b"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 186.42,
    y: 117.82,
    width: 4.53,
    height: 13.89,
    fill: "#19b24b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.47,112.68a12.72,12.72,0,1,1-12.95,12.74c0-.43,0-.85.07-1.27l12.65,1.25Z",
    fill: "#19b24b",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.27,111.55h.25l-.23,12.7L239.63,123A12.71,12.71,0,0,1,252.27,111.55Z",
    fill: "#19b24b",
    opacity: 0.47,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.59,32.09a14.57,14.57,0,0,1-2.52,2.38c-6.59,4.79-15.77,2-23.33-1C232.42,30.09,224,26.66,215,26.09s-18.59,2.27-24,9.41c-3.07,4-5.55,9.84-10.62,10.12a7,7,0,0,1-5.19-2.11c1.75-3.93,2.73-8.64,4.85-12a36.57,36.57,0,0,1,15.63-13.4C206.28,13.29,218.45,13,230,14.57c9.56,1.31,19.16,3.93,27.1,9.41A72.61,72.61,0,0,1,266.59,32.09Z",
    opacity: 0.69,
    fill: "url(#linear-gradient-15)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.51,52.33c2.85,1.92,6.39,2.47,9.82,2.62a14.16,14.16,0,0,1,3.72.47,3.93,3.93,0,0,1,2.66,2.44A7.13,7.13,0,0,0,296.3,60a.58.58,0,0,0,.29.22.56.56,0,0,0,.46-.24,5.24,5.24,0,0,0,.57-6.24c-1.51-2.33-4.53-3-7.18-3.89A32.22,32.22,0,0,1,281.07,45c-1.65-1.24-5.46-3.85-5.7-.12C275.18,47.83,277.17,50.76,279.51,52.33Z",
    opacity: 0.69,
    fill: "url(#linear-gradient-16)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.93,57.84c1.23-2.79,2.61-5.66,4.94-7.64,2.79-2.35,6.55-3.13,10.14-3.71a62.51,62.51,0,0,1,12.5-1.12,42.27,42.27,0,0,1,22.72,8c5.41,3.83,11,9.06,17.55,8.15,5.64,2.79-2.24,10.75-4.32,9.9-4.25-1.75-12.93-9.85-17.14-11.7-8.28-3.64-17.66-3.4-26.7-2.79a15.67,15.67,0,0,0-6.26,1.31,13.7,13.7,0,0,0-4.59,4.53,25.24,25.24,0,0,0-4.15,8.51c-.57,2.36.43,5.52-2.68,4.46C184.91,73.37,188,62.32,189.93,57.84Z",
    opacity: 0.69,
    fill: "url(#linear-gradient-17)",
    style: {
      isolation: "isolate"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.7b6060461b9b4ec6210ae6a0b80e8939.svg";
export { ForwardRef as ReactComponent };